var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    { attrs: { title: _vm.listTitle } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage ml-3 mr-3" },
          [
            _c(
              "b-row",
              { staticClass: "justify-content-start" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "4", lg: "2", xl: "1" } },
                  [_c("back-button", { attrs: { returnUrl: _vm.returnUrl } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "mb-5",
                    attrs: { cols: "4", lg: "2", xl: "1" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btnFilter",
                        on: {
                          click: function ($event) {
                            _vm.displayFilter = !_vm.displayFilter
                          },
                        },
                      },
                      [
                        _vm.displayFilter
                          ? _c("i", { staticClass: "fa-light fa-minus" })
                          : _c("i", { staticClass: "fa-light fa-plus" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("filter.fltr")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "mb-5",
                    attrs: { cols: "4", lg: "2", xl: "1" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btnFilter",
                        attrs: { disabled: _vm.activateSpinner },
                        on: {
                          click: function ($event) {
                            return _vm.onRefresh()
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-light fa-rotate-right fs-14px",
                        }),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("common.rfrsh")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "4", lg: "3", xl: "2" } },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "secondary" },
                        on: { click: _vm.actionAdd },
                      },
                      [
                        _c("i", { staticClass: "fa-light fa-plus" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("common.email.email_address_add"))
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              {
                staticClass: "justify-content-start align-items-center mb-5",
                class: {
                  "filter-item-section": true,
                  "d-none": !_vm.displayFilter,
                },
              },
              [
                _c(
                  "b-col",
                  { staticClass: "form-group", attrs: { sm: "3" } },
                  [
                    _c("form-write-group-label-input", {
                      attrs: {
                        inputLabel: _vm.$t("common.email.email_address_name"),
                      },
                      on: { input: _vm.applyFilter },
                      model: {
                        value: _vm.Name,
                        callback: function ($$v) {
                          _vm.Name = $$v
                        },
                        expression: "Name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "form-group", attrs: { sm: "3" } },
                  [
                    _c("form-write-group-label-input", {
                      attrs: {
                        inputLabel: _vm.$t("common.email.email_address"),
                      },
                      on: { input: _vm.applyFilter },
                      model: {
                        value: _vm.Email,
                        callback: function ($$v) {
                          _vm.Email = $$v
                        },
                        expression: "Email",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "d-flex justify-content-end",
                    attrs: { sm: "2" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn mr-3",
                        attrs: {
                          size: "sm",
                          disabled: !_vm.Name && !_vm.Email,
                        },
                        on: { click: _vm.clearFilterFields },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("filter.clr_fltr_field")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("b-row", { staticClass: "justify-content-center mb-5" }, [
              _c(
                "div",
                [
                  _vm.activateSpinner
                    ? _c("spinner")
                    : _vm.listItemsEmailAddress.length > 0
                    ? _c("b-table", {
                        key: _vm.refreshKey,
                        staticClass: "table-striped",
                        attrs: {
                          items: _vm.listItemsEmailAddress,
                          fields: _vm.fields,
                          "sort-by": _vm.sortBy,
                          fixed: "",
                          hover: "",
                          selectable: _vm.listItemsEmailAddress.length > 0,
                          "empty-text": _vm.$t("common.security.no_result"),
                        },
                        on: {
                          "update:sortBy": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function ($event) {
                            _vm.sortBy = $event
                          },
                          "row-selected": _vm.onRowSelected,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(Name)",
                            fn: function (data) {
                              return [_c("span", [_vm._v(_vm._s(data.value))])]
                            },
                          },
                          {
                            key: "cell(Email)",
                            fn: function (data) {
                              return [_c("span", [_vm._v(_vm._s(data.value))])]
                            },
                          },
                          {
                            key: "cell(edit)",
                            fn: function (data) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-center d-inline-block py-3 w-100",
                                    on: {
                                      click: function ($event) {
                                        return _vm.actionEdit(
                                          $event,
                                          data.item.IdEmailAddress
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-regular fa-pencil",
                                    }),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(delete)",
                            fn: function (data) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-center d-inline-block py-3 w-100",
                                    on: {
                                      click: function ($event) {
                                        return _vm.actionDelete(
                                          $event,
                                          data.item.IdEmailAddress
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-regular fa-trash",
                                    }),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      })
                    : _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c("span", { staticClass: "noResult" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("common.no_result")) +
                                "\n            "
                            ),
                          ]),
                        ]
                      ),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }